import type { SearchError, SearchResults } from "@shared/graphql.types";

export const isSearchSuggestionsResult = (
  result?: SearchError | SearchResults
): result is SearchResults => {
  return result?.__typename === "SearchResults" && "products" in result;
};

export const isSearchError = (
  error?: SearchError | SearchResults
): error is SearchError => {
  return error?.__typename === "SearchError" && "errorCode" in error;
};

export const sanitizeQueryStringParam = (param: string): string => {
  return encodeURIComponent(param.replace(/^\/+/, ""));
};
